import { ComponentMap } from '@cinch-nx/data-storyblok'
import { FaqAccordion } from '@cinch-nx/landing-ui-shared'
import { FeatureSection } from '@cinch-nx/landing-ui-shared'
import { ImageObject } from '@cinch-nx/landing-ui-shared'
import { RichTextSection } from '@cinch-nx/landing-ui-shared'
import { Video } from '@cinch-nx/landing-ui-shared'

import {
  LatestCarsSection,
  LinksSection,
  SEOTable,
  TextInlineImage,
} from '../components'

export const storyblokComponents: ComponentMap = {
  FaqSection: FaqAccordion,
  YoutubeVideo: Video,
  LatestCarsSection: LatestCarsSection,
  RichTextSection,
  FeatureSection,
  LinksSection,
  TextInlineImage,
  Image: ImageObject,
  TableSection: SEOTable,
}
